import { post, put, get, del } from '../utils/bank-statement-api-utils';
import { getAuthToken } from '../utils/cookie-utils';

export const getstatementTransactions = ({
  token,
  page_number,
  page_size,
  lead_id,
  applicant_id,
  doc_id
}) =>
  get(
    `GET/transactions?token=${token}&page_number=${page_number}&page_size=${page_size}&lead_id=${lead_id}&applicant_id=${applicant_id}&doc_id=${doc_id}`
  ).then(({ data }) => data);

export const addBankStatementTransaction = ({ payLoad, headers }) =>
  post(`POST/transaction/`, payLoad, headers).then(({ data }) => data);

export const updateBankStatementTransaction = ({ payLoad, headers }) =>
  post(`UPDATE/transaction/`, payLoad, headers).then(({ data }) => data);

export const getBankStatementPrimaryTags = () =>
  get('GET/primary-tags/').then(({ data }) => data);

export const getBankStatementMeataData = body =>
  post('POST/meta-data-extraction/', body).then(({ data }) => data);

export const getInsightCountAndValuesData = ({
  type,
  leadId,
  applicantId,
  docId
}) =>
  get(
    `GET/${type}/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}`
  ).then(({ data }) => data);

export const getBalanceOverview = ({
  days,
  leadId,
  applicantId,
  docId,
  pageNumber,
  pageSize
}) => {
  return get(
    `GET/balance_overview/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}&day=${days}&page_number=${pageNumber}&page_size=${pageSize}`
  ).then(({ data }) => data);
};

export const getMinMaxAvg = ({
  leadId,
  applicantId,
  docId,
  pageNumber,
  pageSize
}) => {
  return get(
    `GET/min_max_avg/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}&page_number=${pageNumber}&page_size=${pageSize}`
  ).then(({ data }) => data);
};

export const getMonthlyAvgBalance = ({ leadId, applicantId, docId }) => {
  return get(
    `GET/month_average/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}`
  );
};

export const getDepositsWithdrawals = ({ leadId, applicantId, docId }) => {
  return get(
    `GET/monthly_deposits_withdrawl/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}`
  );
};

export const getNetCashFlow = ({
  leadId,
  applicantId,
  docId,
  pageNumber,
  pageSize
}) => {
  return get(
    `GET/net_cash_flow/?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}&page_number=${pageNumber}&page_size=${pageSize}`
  ).then(({ data }) => data);
};

export const getNetCashFlowMetaData = ({ leadId, applicantId, docId }) => {
  return get(
    `GET/net_cash_flow_meta_data?token=${getAuthToken()}&lead_id=${leadId}&applicant_id=${applicantId}&doc_id=${docId}`
  ).then(({ data }) => data);
};
